import React, { useState } from "react";

interface SectionHeaderProps {
  title: string;
  children: React.ReactNode;
  collapsible?: boolean;
  defaultOpen?: boolean;
  badge?: React.ReactNode;
}

export default function SectionHeader({
  title,
  children,
  collapsible = false,
  defaultOpen = true,
  badge,
}: SectionHeaderProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="mb-4">
      <div
        className={`flex justify-between items-center ${open ? "mb-3" : "mb-0"} ${collapsible ? "cursor-pointer" : ""}`}
        onClick={() => collapsible && setOpen(!open)}
      >
        <div className="flex items-center gap-3">
          {collapsible && (
            <span
              className="token-11 text-glass-muted transition-transform duration-200"
              style={{
                transform: open ? "rotate(90deg)" : "rotate(0deg)",
              }}
            >
              ▶
            </span>
          )}
          <div className="section-bar" />
          <h3 className="m-0 token-14s">{title}</h3>
        </div>
        {badge}
      </div>
      {(!collapsible || open) && children}
    </div>
  );
}
